"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const component_context_1 = require("./context/component.context");
const use_additional_context_value_1 = require("./context/use-additional-context-value");
const actions_1 = require("./actions");
const block_skeleton_1 = require("./block-skeleton");
const body_1 = require("./body");
const body_skeleton_1 = require("./body-skeleton");
const error_1 = require("./error");
const header_1 = require("./header");
const header_back_1 = require("./header-back");
const header_hero_1 = require("./header-hero");
const header_image_1 = require("./header-image");
const header_skeleton_1 = require("./header-skeleton");
const toast_1 = require("./toast");
const webview_context_provider_1 = require("./webview-context-provider");
const content_transitions_module_css_1 = __importDefault(require("./content-transitions.module.css"));
const index_module_css_1 = __importDefault(require("./index.module.css"));
const transitions_module_css_1 = __importDefault(require("./transitions.module.css"));
/**
 * Используем в случаях, когда дополнительной информации и действий много, но не хочется уводить пользователя
 * из контекста и пространства продукта.
 *
 * [Макет](https://www.figma.com/design/OiFlIdSpmFYZ5zsFGWA3TD/Web-%3A%3A-Alfa-Online-Composites?node-id=53314-451129)
 *
 * ### Правила размещения `children`
 *
 * Сначала обязательно размещается **один** из следующих компонентов:
 *
 * - `Header`
 * - `HeaderBack`
 * - `HeaderSkeleton`
 * - `HeaderHero`
 * - `HeaderImage`.
 *
 * Дальше обязательно:
 *
 * - `Body` может содержать в себе
 *      - `Skeleton` (используется для поблочной загрузки)
 * - `BodySkeleton` используется как замена `Body` на время загрузки данных
 * - `Error` может использоваться как замена `Body`, так и внутри
 *
 * В конце необязательные элементы:
 *
 * - `Toast` *или*
 * - `Actions`
 */
const SidePanelComponent = (_a) => {
    var { className, transitionProps, nativeScrollbar = true } = _a, otherProps = __rest(_a, ["className", "transitionProps", "nativeScrollbar"]);
    const contextValue = (0, use_additional_context_value_1.useAdditionalContextValue)();
    return ((0, jsx_runtime_1.jsx)(component_context_1.AdditionalContext.Provider, { value: contextValue, children: (0, jsx_runtime_1.jsx)(side_panel_1.SidePanel, Object.assign({ nativeScrollbar: nativeScrollbar, transitionProps: Object.assign(Object.assign({}, transitionProps), { classNames: transitions_module_css_1.default }), contentTransitionProps: {
                classNames: content_transitions_module_css_1.default,
            } }, otherProps, { className: (0, classnames_1.default)(index_module_css_1.default.root, className) })) }));
};
exports.SidePanel = Object.assign(SidePanelComponent, {
    Actions: actions_1.Actions,
    Body: body_1.Body,
    BodySkeleton: body_skeleton_1.BodySkeleton,
    BlockSkeleton: block_skeleton_1.BlockSkeleton,
    Error: error_1.Error,
    Header: header_1.Header,
    HeaderBack: header_back_1.HeaderBack,
    HeaderImage: header_image_1.HeaderImage,
    HeaderSkeleton: header_skeleton_1.HeaderSkeleton,
    HeaderHero: header_hero_1.HeaderHero,
    Toast: toast_1.Toast,
    WebviewContextProvider: webview_context_provider_1.WebviewContextProvider,
});
